import type { SVGProps } from 'react'
const LinePlayCircleVideoSmall = (
	props: SVGProps<SVGSVGElement> & { secondaryColor?: string },
) => (
	<svg
		width={props.width || 24}
		height={props.height || 24}
		viewBox={`0 0 ${props.width || 24} ${props.height || 24}`}
		fill={props.fill || 'none'}
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12 2C6.485 2 2 6.485 2 12C2 17.515 6.485 22 12 22C17.515 22 22 17.515 22 12C22 6.485 17.515 2 12 2ZM16.385 12.85L11.025 16.15C10.865 16.25 10.685 16.3 10.5 16.3C10.335 16.3 10.165 16.26 10.015 16.175C9.7 16 9.505 15.665 9.505 15.3V8.695C9.505 8.335 9.7 8 10.015 7.82C10.33 7.64 10.72 7.655 11.025 7.84L16.385 11.14C16.685 11.325 16.86 11.64 16.86 11.99C16.86 12.34 16.68 12.66 16.385 12.84V12.85Z"
			fill={props.color || 'white'}
		/>
	</svg>
)
export { LinePlayCircleVideoSmall }
